(ns teamoesterreich.admin-mode.lebensretter.lr-user.toe-list
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.marker-modal :as marker-modal]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.lebensretter.lr-user.toe-last-changed :as toe-last-changed]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [reagent.core :as r]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.lebensretter.lr-user.toe-sort-table :as table]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [teamoesterreich.admin-mode.ticket.ticket-modal :as ticket-modal]
            [teamoesterreich.admin-mode.modal.send-message-modal :as send-message-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.multi-marker-modal :as multi-marker-modal]
            [teamoesterreich.admin-mode.modal.info-modal :as info-modal]
            [teamoesterreich.admin-mode.static-data :as staticData]
            [reagent-material-ui.icons.search :refer [search]]

            [reagent-material-ui.icons.check-box-outline-blank :refer [check-box-outline-blank]]
            [reagent-material-ui.icons.check-box :refer [check-box]]
            [reagent-material-ui.icons.indeterminate-check-box-outlined :refer [indeterminate-check-box-outlined]]
            [reagent-material-ui.icons.check-box :refer [check-box]]
            [teamoesterreich.setup :refer [config]]
            [teamoesterreich.util.log :as log]))

(defn event-value
  [^js/Event e]
  (h/event-value e))

(defn get-list [!elms !loaded !invalidated !search !sortCol !reverse !filterLr !filter]
  (reset! !invalidated false)
  (d-user/get-user-list-lebensretter
    (merge {:sort                @!sortCol
            :reverse             @!reverse
            :srch                @!search
            :filter-lebensretter @!filterLr
            :filter              (when !filter @!filter)
            }

           )
    (fn [data]
      (reset! !elms data)
      (reset! !loaded true)
      )))

(defn get-list-cnt [!cnt !filterLr !filter]
  (d-user/get-user-list-lebensretter-cnt
    (merge {:filter-lebensretter @!filterLr
            :filter              (when !filter @!filter)})
    (fn [data]
      (reset! !cnt data)
      )))


(defn count-true [map_]
  (count (filter second map_)))



(defn get-sort-filter-rows [elms]
  (let [ids (get elms "ids")
        rows (if ids (into [] (map-indexed (fn [idx tomId] {:index (inc idx) :tomId tomId}) ids)) [])]
    rows))



(defonce DST_LIST staticData/DST_LIST)
(defonce DEP_LIST staticData/DEP_LIST)

(defn table-column [!st]
  (let [!elms (r/cursor !st [:data])
        rows (get-sort-filter-rows @!elms)
        cnt-rows 1]                                         ;(get @!elms "cnt")]
    (if (> cnt-rows 0)
      [(table/table !st rows)]
      [:h3 "Keine Ergebnisse gefunden!"])
    ))

(defn lr-tabs [!tab0 !tab !filterLr !cnt !loaded !selected]
  (let [tab0 (if (nil? @!tab0) (reset! !tab0 "non-active") @!tab0)
        tab (if (nil? @!tab) (reset! !tab (or (when (= tab0 "non-active") "waiting") (when (= tab0 "active") "qWaiting") "lastChanged")) @!tab)]
    [:<>
     [mui/grid
      {:item  true
       :lg    12
       :xs    12
       :style {:height "50px"}
       }
      [mui/tabs {:value          tab0
                 :onChange       (fn [x i y] (log/debug "set tab0 " x i y)
                                   (reset! !tab0 i)
                                   (reset! !tab (case tab0
                                                  "active" "qWaiting"
                                                  "non-active" "waiting"
                                                  "lastChanged" "lastChanged"))
                                   (reset! !filterLr i)
                                   (reset! !selected {})
                                   (reset! !loaded false)
                                   )
                 :indicatorColor "primary"
                 :textColor      "primary"
                 :variant        "scrollable"
                 }
       ;[mui/tab {:value "action" :style {:verticalAlign "top"} :label (str "Ticket! (" (:action @!cnt) ")")}]
       [mui/tab {:value "active" :style {:verticalAlign "top"} :label (str "Freigeschaltet (" (+ (:active @!cnt) (:qWaiting @!cnt) (:qMissing @!cnt) (:qExtendable @!cnt)) ")")}]
       [mui/tab {:value "non-active" :style {:verticalAlign "top"} :label (str "Nicht freigeschaltet (" (+ (:expired @!cnt) (:documentsMissing @!cnt) (:waiting @!cnt) (:profileMissing @!cnt)) ")")}]
       [mui/tab {:value "lastChanged" :style {:verticalAlign "top"} :label (str "Meine bearbeiteten")}]
       ]
      ]

     [mui/grid
      {:item  true
       :lg    12
       :xs    12
       :style {:height "50px"}
       }
      (into [mui/tabs {:value          tab
                       :onChange       (fn [x i y] (log/debug "set tab " x i y)
                                         (reset! !tab i)
                                         (reset! !filterLr i)
                                         (reset! !selected {})
                                         (reset! !loaded false)
                                         )
                       :indicatorColor "primary"
                       :textColor      "primary"
                       :variant        "scrollable"
                       }]
            (case tab0
              "active"
              [;[mui/tab {:value "action" :style {:verticalAlign "top"} :label (str "Ticket! (" (:action @!cnt) ")")}]
               [mui/tab {:value "active" :style {:verticalAlign "top"} :label (str "Aktive (" (:active @!cnt) ")")}]
               (when (= (:client config) "toe") [mui/tab {:value "qWaiting" :style {:verticalAlign "top" :min-width "300px"} :label (str "Qualifikation vorhanden (" (:qWaiting @!cnt) ")")}])
               (when (= (:client config) "toe") [mui/tab {:value "qMissing" :style {:verticalAlign "top" :min-width "300px"} :label (str "Qualifikation fehlt (" (:qMissing @!cnt) ")")}])
               (when (= (:client config) "toe") [mui/tab {:value "qExtendable" :style {:verticalAlign "top" :min-width "300px"} :label (str "Qualifikation verlängerbar (" (:qExtendable @!cnt) ")")}])
               ]
              "non-active"
              [[mui/tab {:value "expired" :style {:verticalAlign "top"} :label (str "Abgelaufen (" (:expired @!cnt) ")")}]
               [mui/tab {:value "waiting" :style {:verticalAlign "top" :min-width "300px"} :label (str "Dokumente vorhanden (" (:waiting @!cnt) ")")}]
               [mui/tab {:value "documentsMissing" :style {:verticalAlign "top" :min-width "300px"} :label (str "Dokumente fehlen (" (:documentsMissing @!cnt) ")")}]
               [mui/tab {:value "profileMissing" :style {:verticalAlign "top" :min-width "300px"} :label (str "Profil unvollständig (" (:profileMissing @!cnt) ")")}]
               ]
              "lastChanged"
              []
              ))
      ;[mui/tab {:value "99" :style {:verticalAlign "top"} :label "Debug"}]

      ]
     ])
  )

(defn multiselect-action [!elms]
  (let [!st-selected (r/cursor vstate/app-state [:lr-list :selected])
        !st-selection-action (r/cursor vstate/app-state [:lr-list :selection-action])
        select-first-fn (fn [& [max]] (reset! !st-selected (reduce (fn [c tomId] (assoc c tomId true)) @!st-selected (take (or max 1000000) (get @!elms "ids")))))
        !show-send-mail-multiple (r/cursor vstate/app-state [:toe-map :activeSendMailMultiple])
        !show-setMarker-multiple (r/cursor vstate/app-state [:toe-map :activeSetMarkerMultiple])
        !show-message-sent (r/cursor vstate/app-state [:toe-map :activeMessageSent])
        !show-send-mail (r/cursor vstate/app-state [:toe-map :activeSendMail])
        ]

    [:div
     [mui/icon-button {:title   "Alle abwählen"
                       :onClick #(reset! !st-selected {})
                       } [check-box-outline-blank {:fontSize "small"}]]
     [mui/icon-button {:title   "Alle wählen"
                       :onClick #(select-first-fn)
                       } [check-box {:fontSize "small"}]]
     [(send-message-modal/email-template-modal !show-send-mail-multiple "lebensretter" (str "Email erstellen und an " (when @!show-send-mail-multiple (count @!show-send-mail-multiple)) " Personen senden:") "senden"
                                               (fn [subject email from] (d-user/email-to-tomIds (mapv first @!show-send-mail-multiple) subject email from #(reset! !show-message-sent @!show-send-mail)))
                                               nil
                                               (fn [subject email from] (d-user/email-to-tomIds (mapv first @!show-send-mail-multiple) subject email from #(reset! !show-message-sent @!show-send-mail) :self))
                                               )]
     [multi-marker-modal/get-modal !show-setMarker-multiple]
     [mui/select
      {:style        {:width "300px"}
       :defaultValue "-"
       :onChange     (fn [e] (reset! !st-selection-action (h/event-value e)))
       }
      [mui/menu-item {:value "-"} (str (count-true @!st-selected) " Auswahl")]
      [mui/menu-item {:value "mailTo"} "-> `Email senden`"]
      [mui/menu-item {:value "setMarker"} "Marker setzen"]
      ]
     [mui/button {:disabled (if (or (nil? @!st-selection-action) (empty? @!st-selected) (= @!st-selection-action "-")) true false)
                  :onClick  (fn []
                              (log/debug "übernehmen clicked " @!st-selection-action @!st-selected)
                              (case @!st-selection-action
                                "mailTo" (reset! !show-send-mail-multiple @!st-selected)
                                "setMarker" (reset! !show-setMarker-multiple @!st-selected)
                                :else nil))
                  } "übernehmen"]
     ]))

(defn result-chip [!elms]
  [mui/chip {:style {:verticalAlign "center" :margin "0px 0 7px 0"}
             ;:disabled "disabled"
             :icon  (r/as-element [search])
             :title "Zur aktuellen Auswahl hinzufügen"
             :label (str (get @!elms "cnt") " Einträge gefunden")}]

  )

(defn filter-check-box [name key !filter !waiting? !invalidated]
  [mui/form-control-label {:label   (r/as-element [:span {:style {:fontSize "smaller" :overflow "none" :white-space "nowrap"}} name])
                           :value   (get @!filter key) :placement "start"
                           :control (r/as-element [mui/checkbox {:checked  (if (true? (get @!filter key)) true false)
                                                                 :onChange (h/wait-do-check !waiting? (fn [val]
                                                                                                        (log/debug "wait-do " key val)
                                                                                                        (swap! !filter assoc key val)
                                                                                                        (reset! !invalidated true)))
                                                                 }])}])

(defn onOff-filter-check-box [name key !filter !waiting? !invalidated]
  [mui/form-control-label {:label   (r/as-element [:span {:style {:fontSize "smaller" :overflow "none" :white-space "nowrap"}} name])
                           :value   (get @!filter key) :placement "start"
                           :control (r/as-element
                                      [mui/icon-button {

                                                        :onClick (h/wait-do-check !waiting? (fn [_]
                                                                                              (let [val (case (get @!filter key)
                                                                                                          1 -1
                                                                                                          -1 0
                                                                                                          1)]
                                                                                                (log/debug "wait-do " key val)
                                                                                                (swap! !filter assoc key val)
                                                                                                (reset! !invalidated true))))
                                                        }
                                       ;[check-box {:fontSize "small"}]
                                       (case (get @!filter key)
                                         1 [check-box {:style {:color "green"}}]
                                         -1 [indeterminate-check-box-outlined {:style {:color "red"}}]
                                         [check-box-outline-blank {}])
                                       ]

                                      )}]

  )
(defn search-field [!search !waiting? !invalidated]
  [mui/text-field
   {:default-value (str @!search)
    :placeholder   "suche..."
    :style         {:float     "left" :margin "5px 5px 5px 25px" :display "inline-block" :width "300px"
                    :textAlign "left"}
    :onChange      (h/wait-do !waiting? (fn [val]
                                          (reset! !search val)
                                          (reset! !invalidated true)))
    :multiline     false}])

(defn render-table []
  (let [!st (r/cursor vstate/app-state [:lr-list])
        !tab0 (r/cursor vstate/app-state [:lr-list :tab0])
        !tab (r/cursor vstate/app-state [:lr-list :tab])
        !filter (r/cursor vstate/app-state [:lr-list :filter])
        !cnt (r/cursor vstate/app-state [:lr-list :cnt])
        !search (r/cursor vstate/app-state [:lr-list :search])
        !sortCol (r/cursor vstate/app-state [:lr-list :sort])
        !reverse (r/cursor vstate/app-state [:lr-list :reverse])
        !elms (r/cursor vstate/app-state [:lr-list :data])
        !map-userPopup (r/cursor vstate/app-state [:toe-map :activeUserPopup])
        !show-new-ticket (r/cursor vstate/app-state [:toe-map :newTicket])
        !show-ticket (r/cursor vstate/app-state [:toe-map :openTicket])
        !show-send-mail (r/cursor vstate/app-state [:toe-map :activeSendMail])
        !show-message-sent (r/cursor vstate/app-state [:toe-map :activeMessageSent])
        !invalidated (r/cursor vstate/app-state [:lr-list :invalidated])
        !loaded (r/cursor vstate/app-state [:lr-list :loaded])
        !log-loaded (r/cursor vstate/app-state [:lr-list :log-loaded])
        !waiting? (r/cursor !st [:waiting])
        !filterLr (r/cursor !st [:filterLr])
        !st-selected (r/cursor vstate/app-state [:lr-list :selected])
        ]

    (fn []
      [:div {:style {:display "flex" :flexDirection "column" :align-items "stretch" :height "100%" :marginTop "20px"}}

       [toe-modal/get-modal !map-userPopup]
       [info-modal/info-modal !show-message-sent "Diese Nachricht(en) wurde gesendet!" "Ok" (fn [])]
       [(ticket-modal/new-ticket-modal !show-new-ticket :lebensretter (fn []))]
       [(ticket-modal/ticket-modal !show-ticket)]
       [(send-message-modal/email-template-modal !show-send-mail "lebensretter" (str "Email erstellen und an " @!show-send-mail " senden:") "senden"
                                                 (fn [subject email from] (d-user/email-to-tomIds [@!show-send-mail] subject email from #(reset! !show-message-sent true)))
                                                 nil
                                                 (fn [subject email from] (d-user/email-to-tomIds [@!show-send-mail] subject email from #(reset! !show-message-sent true) :self))
                                                 )]


       [mui/grid
        {:container     true
         :direction     "row"
         :alignItems    "stretch"
         :justify       "flex-start"
         :spacing       0
         :columnSpacing 0
         :style         {:flex "0 0 160px"}
         }
        [mui/grid
         {:item  true
          :xs    2
          :style {:height "50px"}
          }
         ]

        [mui/grid
         {:item  true
          :xs    8
          :style {:height "50px"}
          }

         [mui/typography {:variant "h5" :style {:margin "7px 0 0 0"}
                          :onClick (fn [] (reset! !loaded false))}
          "Lebensretter Liste"]]

        [mui/grid
         {:item  true
          :xs    2
          :style {:height "50px" :text-align "right"}
          }
         [ws-event-sync-component/ws-event-reload !loaded :lrClearance]
         ]

        [mui/grid
         {:item  true
          :lg    6
          :xs    10
          :style {:minHeight "50px" :marginBottom "20px"}
          }
         [org-selector/get-selector !filter #(reset! !loaded false) (d-rights/get-rights-orgId-filter d-rights/LEBENSRETTER)]
         ]

        [mui/grid
         {:item true
          :lg   6
          :xs   2
          }]





        [lr-tabs !tab0 !tab !filterLr !cnt !loaded !st-selected]

        ;;filter

        [mui/grid
         {:item true
          :lg   3
          :xs   4
          }
         [search-field !search !waiting? !invalidated]
         ]
        [mui/grid
         {:item true
          :lg   9
          :xs   8
          }
         [onOff-filter-check-box [marker-modal/markerIcon :new] :marker_new !filter !waiting? !invalidated]
         [onOff-filter-check-box [marker-modal/markerIcon :ok] :marker_ok !filter !waiting? !invalidated]
         [onOff-filter-check-box [marker-modal/markerIcon :userWait] :marker_userWait !filter !waiting? !invalidated]
         [onOff-filter-check-box [marker-modal/markerIcon :process] :marker_process !filter !waiting? !invalidated]
         [onOff-filter-check-box [marker-modal/markerIcon :givenUp] :marker_givenUp !filter !waiting? !invalidated]

         [:span {:style {:display "inline-block" :width "120px"}} ""]

         (when (= @!tab "profileMissing")
           [:span
            [onOff-filter-check-box "Email validiert" :emailValid !filter !waiting? !invalidated]
            [onOff-filter-check-box "Handy validiert" :handyValid !filter !waiting? !invalidated]
            ])
         (when (= @!tab "documentsMissing")
           [:span
            [onOff-filter-check-box "Identität Dokument " :documentIdentity !filter !waiting? !invalidated]
            [onOff-filter-check-box "Selbsterklärung Dokument " :documentSelfexplain !filter !waiting? !invalidated]
            ])
         (when (= @!tab "waiting")
           [:span
            [onOff-filter-check-box "Identität bestätigt" :identityConfirmed !filter !waiting? !invalidated]
            [onOff-filter-check-box "Selbsterklärung bestätigt" :selfExplainConfirmed !filter !waiting? !invalidated]
            ])
         ]
        ]
       [mui/grid
        {:container     true
         :direction     "row"
         :alignItems    "stretch"
         :justify       "flex-start"
         :spacing       0
         :columnSpacing 0
         }

        [mui/grid
         {:item  true
          :xs    8
          :style {:margin    "7px 0 0 0"
                  :height    "60px"
                  :textAlign "left"}
          }
         [multiselect-action !elms]]

        [mui/grid
         {:item  true
          :xs    4
          :style {:height "50px" :paddingTop "10px"}
          }
         (when-not (= @!tab0 "lastChanged") [result-chip !elms])
         ]

        (when (true? @!invalidated) (get-list !elms !loaded !invalidated !search !sortCol !reverse !filterLr !filter) "")
        ]
       (if-not @!loaded
         (do
           (get-list !elms !loaded !invalidated !search !sortCol !reverse !filterLr !filter)
           (get-list-cnt !cnt !filterLr !filter)
           [:div
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
            [mui/typography {} "Lade Daten ... "]
            ]
           )
         [:div
          {:style {:background-color "white" :flex "10 10 250px"}}
          (if (= @!tab0 "lastChanged")
            [toe-last-changed/table-column !st]
            [table-column !st])
          ]

         )
       ]

      )))

(defn get-it []
  [(render-table)])